module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAABIUlEQVQokY3SSyuuURgG4Ot7fQMpJDmM/QCTNXM22Ex25FBKEr+AzEzULsVE/gBJxmLv2hRmDhmRZCIDSQkZMd0YvEvZr4/ctVqr5z60nrWeXAgBKjGFHtTgEkuYk2ICI6jDLdbxCw8JqnCAF7SjFINoxEZcTRiKXDueo6cqF0JYwD0m/Y8i/InnLvzL8DOozoUQ7lGPGx9RGfeHAlwtzvIowWMBwWfGNzyhOMEu+r8QfoZe7Oelvf/FBfa+aW7ALH4mOMYwVtH5DXMH1qTfepTE4g66sezrdvqwIp2XLci/Iw/xA5sox2LGPIrpeIOTt2I+IzpFW0wvw3ysj2NMOkTn7w3ZANLHbME2KqRTN4BWXGXFhQLgGs34jSSa7woJXwFuqTm/35KblgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/收藏.png
// module id = qNCa
// module chunks = 1